import React, { useEffect, useState } from 'react';
import { Container, Typography, CircularProgress } from '@mui/material';
import axios from 'axios';
import ComicList from './ComicList'; // Giả định bạn đã có component ComicList
import { useMediaQuery } from '@mui/material'; // Thêm import này


const SearchBar = () => {
  const [searchResults, setSearchResults] = useState([]); // Kết quả tìm kiếm
  const [loading, setLoading] = useState(true); // Trạng thái đang tải
  const [error, setError] = useState(null); // Lỗi
  const [searchTerm, setSearchTerm] = useState(''); // Từ khóa tìm kiếm

  const isMobile = useMediaQuery('(max-width: 750px)'); // Kiểm tra nếu màn hình nhỏ hơn 560px

  // Hàm thực hiện tìm kiếm
  const handleSearch = async (term) => {
    if (term.trim() === '') return;

    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(`https://otruyenapi.com/v1/api/tim-kiem?keyword=${term}`);
      setSearchResults(response.data.data.items); // Lưu kết quả tìm kiếm
    } catch (err) {
      setError('Có lỗi xảy ra khi tìm kiếm');
    } finally {
      setLoading(false);
    }
  };

  // Lấy từ khóa tìm kiếm từ URL
  const getQueryParam = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('q'); // Lấy giá trị của tham số "q"
  };

  useEffect(() => {
    const term = getQueryParam(); // Lấy từ khóa tìm kiếm từ URL
    if (term) {
      setSearchTerm(term);
      handleSearch(term); // Gọi hàm tìm kiếm với tham số tìm kiếm
    } else {
      setLoading(false); // Nếu không có từ khóa, ngừng tải
    }
  }, []); // Chỉ chạy một lần khi component được mount

  return (
    <Container className="app-container">
      <Typography variant={isMobile ? 'h6' : 'h5'} component="h1" gutterBottom>
        Tìm kiếm: <strong>{searchTerm}</strong>
      </Typography>
      <hr style={{ margin: '20px 0', border: '1px solid #ccc' }} />
      
      {loading ? (
        <CircularProgress />
      ) : error ? (
        <p>{error}</p>
      ) : (
        <ComicList comics={searchResults} /> // Hiển thị danh sách truyện tìm kiếm
      )}
    </Container>
  );
};

export default SearchBar;
